export const analytics = {
botWise: {
    botWiseAnalytics: 'Bot-specifik analys',
    currentBillingCycle: 'Nuvarande faktureringscykel',
    currentMonth: 'Nuvarande månad',
    sinceAccountCreation: 'Sedan kontoskapande',
    messages: 'Meddelanden',
    leads: 'Leads',
    noDataFound: {
      botwiseAnalytics: 'Bot-specifik analys',
      noBotHasBeenCreatedYet: 'Ingen bot har skapats ännu!',
    },
    appTooltip: {
      TOOLTIP_BOTWISE_SUMMARY: 'Sammanfatta data från meddelanden och kontakter/leads för specifika botar för nuvarande faktureringscykel, nuvarande månad eller sedan kontoskapande (Uppdateras varje midnatt)',
      TOOLTIP_FILTERS: 'Filtrera data för vald bot',
      TOOLTIP_MESSAGES: 'Totalt antal meddelanden konsumerade av ditt konto sedan kontoskapande',
      TOOLTIP_LEADS: 'Totalt antal leads fångade av botar för ditt konto sedan kontoskapande.',
    }
},
overview: {
    analytics: 'Analys',
    seeHowToUse: 'Se hur man använder',
    help: 'Hjälp',
    overview: 'Översikt',
    messages: 'Meddelanden',
    leads: 'Leads',
    appTooltip: {
      TOOLTIP_OVERVIEW_TITLE: 'Analys för alla dina botmeddelanden och leads. (Data uppdateras varje midnatt)',
    }
},
summary: {
    analyticsSummary: 'Analys Sammanfattning',
    allBots: 'Alla Bots',
    daily: 'Daglig',
    weekly: 'Veckovis',
    monthly: 'Månadsvis',
    messages: 'Meddelanden',
    leads: 'Leads',
    appTooltip: {
      TOOLTIP_ANALYTICS_SUMMARY: 'Sammanfatta daglig, veckovis eller månatlig data från meddelanden och kontakter/leads för specifika och alla botar (Uppdateras varje midnatt)',
    }
},
whatsapp: {
    analyticsCount: {
      whatsappAnalytics: 'WhatsApp Analys',
      month: 'Månad',
      week: 'Vecka',
      today: 'Idag',
      filters: 'Filter',
      clearAll: 'Rensa allt',
      apply: 'Tillämpa',
      totalConversations: 'Totala konversationer',
      freeConversations: 'Gratis konversationer',
      paidConversations: 'Betalande konversationer',
      messageSent: 'Meddelande skickat',
      messageDelivered: 'Meddelande levererat',
      bpDropDown: {
        selectBot: 'Välj Bot',
      },
      indexMergeDatePicker: {
        startDate: 'Startdatum',
        endDate: 'Slutdatum',
      }
    },
    conversationAnalytics: {
      conversationAnalytics: 'Konversationsanalys',
      month: 'Månad',
      week: 'Vecka',
      today: 'Idag',
      totalConversations: 'Totala konversationer',
      paidConversations: 'Betalande konversationer',
      freeConversations: 'Gratis konversationer',
      indexMergeDatePicker: {
        startDate: 'Startdatum',
        endDate: 'Slutdatum',
      },
      bpDropDown: {
        allBots: 'Alla botar'
      }
    },
    messageAnalytics: {
      whatsappMessages: 'WhatsApp-meddelanden',
      sent: 'Skickat',
      delivered: 'Levererat',
      indexMergeDatePicker: {
        startDate: 'Startdatum',
        endDate: 'Slutdatum',
      },
      bpDropDown: {
        allBots: 'Alla botar'
      },
      month: 'Månad',
      week: 'Vecka',
      today: 'Idag',
    },
    messageStatusAnalytics: {
      whatsappMessagesByStatus: 'WhatsApp-meddelanden efter status',
      sent: 'Skickat',
      delivered: 'Levererat',
      indexMergeDatePicker: {
        startDate: 'Startdatum',
        endDate: 'Slutdatum',
      },
      bpDropDown: {
        allBots: 'Alla botar'
      },
      month: 'Månad',
      week: 'Vecka',
      today: 'Idag',
    },
    newWhatsappAnalytics: {
      allSubscribers: 'Alla prenumeranter',
      whatsappSubscribers: 'WhatsApp-prenumeranter'
    }
}
};
